import React from "react";
import { Avatar, Chip } from "@heroui/react";
import { Typography } from "../../../../../../components";
import { OrderData } from "./utils";
import { useTranslations } from "../../../../../../contexts/translation.context";

interface AccountCellProps {
  order: OrderData;
}

const AccountCell: React.FC<AccountCellProps> = ({ order }) => {
  const { t } = useTranslations();
  //@ts-ignore
  const subscriptionType = order?.model?.type === 'free' ? 'FREE' : order?.model?.type === 'free trial' ? 'Free-Trial' : 'FREE';
  console.log('order', order);
  return (
    <div className="flex items-start gap-3">
      <div className="relative">
        <Avatar
          src={order.account.avatar}
          showFallback name={order?.account.username?.slice(0, 1)}
          className="w-[40px] h-[40px] rounded-[12px]"
        />
      </div>
      <div className="">
        <div className="flex items-center gap-2 mt-1">
          <div className='flex gap-[8px]'>
            <Typography variant="label2" >
              {order?.campaign?.linkSuffix?.slice(-4) || order?.account?.of_id}
            </Typography>
            <div className='flex gap-[2px]'>
              <a
                target="__blank"
                href={`https://onlyfans.com/${order.account.username}`}
                className="text-blue-600 hover:underline flex items-center gap-1"
              >
                <Typography variant="body2" className="!text-[#006FEE]">
                  @{order?.account.username}
                </Typography>
              </a>
            </div>
          </div>
        </div>

        {/* Status Chips */}
        <div className="flex flex-wrap gap-[8px] mt-[4px]">
          {/* <Chip
            style={{ backgroundColor: 'rgba(0, 111, 238, 0.2)', color: '#006FEE' }}
            className="h-[20px] px-[8px] text-[12px] font-medium"
          >
            FREE
          </Chip> */}
                    <Chip
            className="bg-[rgba(0,111,238,0.2)] text-[#006fee] rounded-full px-[4px] h-[24px]"
          >
            <span className="text-[12px] leading-[16px]">{subscriptionType}</span>
          </Chip>
          <Chip
            style={{ backgroundColor: 'rgba(245, 165, 36, 0.2)', color: '#F5A524' }}
            className="h-[20px] px-[8px] text-[12px] font-medium"
          >
            {order.account?.overall_popularity_percent || 0}%
          </Chip>
          {/* <Chip
            style={{ backgroundColor: 'rgba(23, 201, 100, 0.2)', color: '#17C964' }}
            className="h-[20px] px-[8px] text-[12px] font-medium"
          >
            {t('orders.account.accessActive')}
          </Chip> */}
          <span className={`inline-flex h-[24px] items-center justify-center rounded-lg px-[8px] text-[12px] font-medium ${
          // @ts-ignore
          order.model.status === 'active'
              ? 'bg-[#17C964]/20 text-[#17C964]'
              // @ts-ignore
              : order.model.status === 'moderation'
              ? 'bg-[#7828C8]/20 text-[#7828C8]'
              : 'bg-[#F31260]/20 text-[#F31260]'
          }`}>
           {/* @ts-ignore */}
            {order.model.status === 'active'
              ? 'Доступ активен'
              // @ts-ignore
              : order.model.status === 'moderation'
              ? 'Модерация'
              : 'Нет доступа'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default AccountCell;
